import React from 'react';

const Disclaimer = () => {
  return (
    <section className='px-6 sm:px-10 xl:px-59 pb-12 md:pb-16 xl:pb-24 2xl:pb-28 mt-28 sm:mt-40'>
      <div className='w-full sm:w-1/2'>
        <h1 className='font-tobias text-2xl sm:text-3xl lg:text-4xl xl:text-40 2xl:text-5xl text-gableGreen'>Disclaimer</h1>
        <div className="mt-8">
          <p className={`${text} mt-4`}>
            Images and plans are intended to be a visual aid and some images may not necessarily depict the actual development or
            buildings. Images of homes may include examples of upgrade items and other items not supplied by builders, such as
            landscaping, water features, pools, pool fences, decorative lighting, and furniture.
          </p>

          <p className={`${text} mt-4`}>
            Intrapac Property Pty Ltd and Coops Joint Venture give no warranty as to the accuracy or sufficiency of any information
            provided, which is subject to change without notice. Prospective purchasers should make their own enquiries and seek
            independent legal advice prior to purchase. Refer to Intrapac Property Pty Ltd and Coops Joint Venture's other marketing
            material and contracts of sale for more information.
          </p>

          <div className="mt-6">
            <div className={`${text} flex`}>
              <span className="mr-2">1.</span>
              <span>
                The content contained in this marketing material (<strong>Material</strong>) that has been provided to you (<strong>Recipient</strong>) including the
                architectural plans (<strong>Plans</strong>), images and information accompanying all plans and images (together, the <strong>Information</strong>) remains at
                all times the intellectual property of Intrapac Property Pty Ltd. and their related entities and agents (together, the
                <strong> Companies</strong>).
              </span>
            </div>
            <div className={`${text} mt-2 flex`}>
              <span className="mr-2">2.</span>
              <span>The Information is provided strictly on the basis of, and subject to, these terms.</span>
            </div>
            <div className={`${text} mt-2 flex`}>
              <span className="mr-2">3.</span>
              <span>
                By taking a copy of the Information, the Recipient acknowledges and represents to the Companies that it has read,
                understood and accepted these terms.
              </span>
            </div>
            <div className={`${text} mt-2 flex`}>
              <span className="mr-2">4.</span>
              <span>
                The Information, including any specifications depicted in any Plans, are current as at the date of issue and are subject to
                Government and Council approval. The Plans and images contained in the Material are approximate and for illustrative
                purposes only. To the extent permitted by law, no guarantees, warranties or representations as to the accuracy and
                completeness of the Information are made.
              </span>
            </div>
            <div className={`${text} mt-2 flex`}>
              <span className="mr-2">5.</span>
              <span>
                All images, visual representations, copy details, samples and artists' representations or renders in the Material are subject to
                Government and Council approval and are for illustrative purposes only.
              </span>
            </div>
            <div className={`${text} mt-2 flex`}>
              <span className="mr-2">6.</span>
              <span>
                The Companies may modify any Plans (including any specifications or dimensions represented on the Plans). It is the
                responsibility of the purchaser to review the specific terms of the contract of sale prior to purchase. The provisions of the
                contract of sale override any inconsistency with these Plans and the Information.
              </span>
            </div>
            <div className={`${text} mt-2 flex`}>
              <span className="mr-2">7.</span>
              <span>
                To the extent permitted by law, the Companies and any of their directors, officers, employees, advisers and agents expressly
                disclaim all liability which may be based on any information, statement or opinion contained in or omitted from the
                Information. The Recipient must not rely upon the Information in any way. The Companies accept no liability for any action
                taken or not taken by any party in reliance on the Information.
              </span>
            </div>
            <div className={`${text} mt-2 flex`}>
              <span className="mr-2">8.</span>
              <span>
                No part of the Information may, in any form or by any means (electronic, mechanical, micro-copying, photocopying,
                recording or otherwise), be reproduced, stored or transmitted or otherwise used without the prior written permission of the
                Companies.
              </span>
            </div>
            <div className={`${text} mt-2 flex`}>
              <span className="mr-2">9.</span>
              <span>
                The Information may also contain third party supplied material, including intellectual property of third party suppliers. The
                same restrictions applying above to the material of the Companies apply to such third party content.
              </span>
            </div>
            <div className={`${text} mt-2 flex`}>
              <span className="mr-2">10.</span>
              <span>
                You agree and consent to the collection and storage of your personal information collected by the Companies in accordance
                with its privacy policy including for the purpose of the Companies maintaining contact with you as a prospective purchaser.
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const text = 'font-mori text-xs lg:text-sm xl:text-base text-gableGreen mt-2';

export default Disclaimer;